import React, { useEffect, useState } from 'react';
import eventBg from "./../green-event-iq-logo.png";
import AppScreenshotSlider from './components/section/AppScreenshotSlider';
const LandingPage = () => {

  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "QR Invitations",
      description: "Beautiful digital invites with unique QR codes",
      color: "from-green-400 to-blue-500"
    },
    {
      title: "Real-time RSVP",
      description: "Track responses and check-ins instantly",
      color: "from-blue-400 to-purple-500"
    },
    {
      title: "Media Sharing",
      description: "Share event photos and videos seamlessly",
      color: "from-purple-400 to-pink-500"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="min-h-screen bg-white">


      {/* Improved Hero Section with Fixed CTA Buttons */}
      <section className="bg-gradient-to-br from-green-50 via-white to-blue-50 py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-green-100 text-green-800 text-sm font-medium mb-6">
                <span className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse"></span>
                Sustainable Event Management
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                Transform Your
                <span className="text-green-600 block">Event Experience</span>
              </h1>

              <p className="text-xl text-gray-600 mb-8 max-w-lg leading-relaxed">
                Create unforgettable events with QR-based invitations, real-time tracking, and sustainability analytics—all while reducing your environmental impact.
              </p>

              {/* Fixed CTA Buttons - Improved Responsive Design */}

              <div className="flex flex-col sm:flex-row items-center sm:items-start  mb-8 gap-4">
                {/* Google Play Button - Always visible */}
                <div className="w-full max-w-xs">
                  <a
                    href="https://play.google.com/store/apps/details?id=in.binalogy.eventplanner"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center px-6 py-4 border border-transparent text-base font-medium rounded-xl text-white bg-green-600 hover:bg-green-700 transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl w-full"
                  >
                    <svg className="w-6 h-6 mr-3 flex-shrink-0" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                    </svg>
                    <div className="text-left flex-1 min-w-0">
                      <div className="text-xs leading-tight">GET IT ON</div>
                      <div className="text-lg font-bold leading-tight truncate">Google Play</div>
                    </div>
                  </a>
                </div>

                {/* App Store Button with Responsive Coming Soon Label */}
                <div className="w-full max-w-xs relative">
                  <div className="relative">
                    <button
                      className="flex items-center justify-center px-6 py-4 border border-gray-300 text-base font-medium rounded-xl text-gray-400 bg-white cursor-not-allowed shadow-lg w-full"
                      disabled
                    >
                      <svg className="w-6 h-6 mr-3 flex-shrink-0" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
                      </svg>
                      <div className="text-left flex-1 min-w-0">
                        <div className="text-xs leading-tight">DOWNLOAD ON THE</div>
                        <div className="text-lg font-bold leading-tight truncate">App Store</div>
                      </div>
                    </button>

                    {/* Responsive Coming Soon Label */}
                    <span className="absolute -top-2 -right-2 bg-yellow-500 text-white text-xs px-2 py-1 rounded-full font-bold shadow-lg animate-bounce whitespace-nowrap">
                      Coming Soon
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex justify-content-center items-center text-gray-500">
                <div className="flex -space-x-2 mr-4">
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="w-8 h-8 rounded-full bg-gradient-to-r from-green-400 to-blue-500 border-2 border-white"></div>
                  ))}
                </div>
                <div className="text-sm">
                  <span className="font-semibold text-gray-700">500+</span> event organizers trust EventIQ
                </div>
              </div>
            </div>

            {/* Enhanced Right Section */}
            <div className="relative">
              {/* Main Phone Mockup */}
              <div className="relative mx-auto w-80">
                {/* Phone Frame */}
                <div className="relative bg-gray-900 rounded-[40px] p-4 shadow-2xl border-[6px] border-gray-800">
                  {/* Notch */}
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-6 bg-gray-800 rounded-b-2xl z-10"></div>

                  {/* Screen */}
                  <div className="bg-white rounded-[32px] overflow-hidden h-96 relative">
                    {/* Animated Background */}
                    <div className={`absolute inset-0 bg-gradient-to-br ${slides[currentSlide].color} transition-all duration-1000`}></div>

                    {/* Screen Content */}
                    <div className="relative z-10 p-6 h-full flex flex-col justify-between">
                      {/* Header */}
                      <div className="text-center text-white">
                        <div className="text-sm opacity-90">EventIQ</div>
                        <div className="text-lg font-bold mt-1">{slides[currentSlide].title}</div>
                        <div className="text-xs opacity-80 mt-1">{slides[currentSlide].description}</div>
                      </div>

                      {/* Central Content */}
                      <div className="flex-1 flex items-center justify-center">
                        {currentSlide === 0 && (
                          <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 w-48">
                            <div className="bg-white/30 rounded-lg p-3 mb-3 text-center text-white text-sm">
                              Create Event
                            </div>
                            <div className="bg-white/30 rounded-lg p-3 text-center text-white text-sm">
                              Add Guests
                            </div>
                          </div>
                        )}
                        {currentSlide === 1 && (
                          <div className="bg-white p-3 rounded-xl shadow-lg">
                            <div className="w-32 h-32 bg-gradient-to-r from-green-400 to-blue-500 rounded-lg flex items-center justify-center">
                              <div className="text-center text-black text-xs">
                                <div className="font-bold">SCAN QR</div>
                                <div className="mt-1">EventIQ</div>
                              </div>
                            </div>
                          </div>
                        )}
                        {currentSlide === 2 && (
                          <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 w-48">
                            <div className="flex items-center justify-between mb-3">
                              <div className="text-white text-xs">Event Gallery</div>
                              <div className="text-white text-xs">📸</div>
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                              {[1, 2, 3, 4].map(i => (
                                <div key={i} className="aspect-square bg-white/30 rounded-lg"></div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Navigation Dots */}
                      <div className="flex justify-center space-x-2">
                        {slides.map((_, index) => (
                          <button
                            key={index}
                            onClick={() => setCurrentSlide(index)}
                            className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentSlide ? 'bg-white scale-125' : 'bg-white/50'
                              }`}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Floating Elements */}
                <div className="absolute -top-4 -right-4 w-24 h-24 bg-green-100 rounded-2xl transform rotate-12 shadow-lg flex items-center justify-center">
                  <div className="text-center">
                    <div className="text-green-600 font-bold text-lg">90%</div>
                    <div className="text-green-600 text-xs">Paper Saved</div>
                  </div>
                </div>

                <div className="absolute -bottom-6 -left-6 w-20 h-20 bg-blue-100 rounded-2xl transform -rotate-6 shadow-lg flex items-center justify-center">
                  <div className="text-center">
                    <div className="text-blue-600 font-bold text-lg">75%</div>
                    <div className="text-blue-600 text-xs">Less Waste</div>
                  </div>
                </div>

                {/* Background Decorative Elements */}
                <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96">
                  <div className="absolute top-0 left-0 w-32 h-32 bg-green-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
                  <div className="absolute top-0 right-0 w-32 h-32 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-1000"></div>
                  <div className="absolute bottom-0 left-0 w-32 h-32 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-500"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Section */}


      {/* Features Section */}
      <section id="features" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Powerful Event Management Features</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Everything you need to plan, manage, and analyze your events sustainably
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Feature 1 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition duration-300">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">QR-Based Invitations</h3>
              <p className="text-gray-600">
                Create beautiful digital invitations with unique QR codes for easy check-in and attendance tracking.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition duration-300">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Real-Time RSVP Tracking</h3>
              <p className="text-gray-600">
                Monitor guest responses in real-time and get instant notifications when attendees check in.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition duration-300">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Event Media Sharing</h3>
              <p className="text-gray-600">
                Upload and share photos and videos from your events in a dedicated gallery for all attendees.
              </p>
            </div>

            {/* Feature 4 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition duration-300">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Sustainability Analytics</h3>
              <p className="text-gray-600">
                Track your event's environmental impact with metrics on paper saved, waste reduction, and carbon footprint.
              </p>
            </div>

            {/* Feature 5 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition duration-300">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Guest Management</h3>
              <p className="text-gray-600">
                Easily manage guest lists, send reminders, and track attendance with our intuitive interface.
              </p>
            </div>

            {/* Feature 6 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition duration-300">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Instant Notifications</h3>
              <p className="text-gray-600">
                Keep everyone informed with real-time updates, reminders, and announcements for your events.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">How EventIQ Works</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Simple steps to create unforgettable, sustainable events
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Step 1 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-green-600 font-bold text-xl">1</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Create Event</h3>
              <p className="text-gray-600">
                Set up your event details, date, venue, and guest list in minutes.
              </p>
            </div>

            {/* Step 2 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-blue-600 font-bold text-xl">2</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Send Invitations</h3>
              <p className="text-gray-600">
                Share QR-based digital invitations via email, message, or social media.
              </p>
            </div>

            {/* Step 3 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-purple-600 font-bold text-xl">3</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Track & Engage</h3>
              <p className="text-gray-600">
                Monitor RSVPs, check-ins, and share media during the event.
              </p>
            </div>

            {/* Step 4 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-yellow-600 font-bold text-xl">4</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Analyze Impact</h3>
              <p className="text-gray-600">
                Review sustainability metrics and event insights for future planning.
              </p>
            </div>
          </div>
        </div>
      </section>
      <AppScreenshotSlider />
      {/* Sustainability Section */}
      <section id="sustainability" className="py-20 bg-green-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Sustainability at the Core</h2>
              <p className="text-lg text-gray-600 mb-6">
                EventIQ is designed with environmental responsibility in mind. By digitizing event processes, we help reduce paper waste, minimize carbon footprint, and promote eco-friendly event practices.
              </p>

              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <p className="ml-3 text-gray-600">Track paper savings with digital invitations</p>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <p className="ml-3 text-gray-600">Monitor food waste reduction metrics</p>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <p className="ml-3 text-gray-600">Calculate carbon footprint of your events</p>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <p className="ml-3 text-gray-600">Get insights for more sustainable future events</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Sustainability Impact</h3>

              <div className="space-y-6">
                <div>
                  <div className="flex justify-between mb-2">
                    <span className="text-gray-700">Paper Saved</span>
                    <span className="font-semibold text-green-600">Up to 90%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-green-600 h-2.5 rounded-full" style={{ width: '90%' }}></div>
                  </div>
                </div>

                <div>
                  <div className="flex justify-between mb-2">
                    <span className="text-gray-700">Waste Reduction</span>
                    <span className="font-semibold text-green-600">Up to 75%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-green-600 h-2.5 rounded-full" style={{ width: '75%' }}></div>
                  </div>
                </div>

                <div>
                  <div className="flex justify-between mb-2">
                    <span className="text-gray-700">Carbon Footprint</span>
                    <span className="font-semibold text-green-600">Reduced by 60%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-green-600 h-2.5 rounded-full" style={{ width: '60%' }}></div>
                  </div>
                </div>

                <div>
                  <div className="flex justify-between mb-2">
                    <span className="text-gray-700">Planning Efficiency</span>
                    <span className="font-semibold text-green-600">Increased by 80%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-green-600 h-2.5 rounded-full" style={{ width: '80%' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-green-600 to-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Transform Your Events?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join the sustainable event revolution. Download EventIQ today and start creating memorable, eco-friendly experiences.
          </p>

          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=in.binalogy.eventplanner"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-green-700 bg-white hover:bg-gray-100 transition duration-300"
              >
                <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                Download on Google Play
              </a>
            </div>
            <div className="relative">
              <button
                className="inline-flex items-center justify-center px-6 py-3 border border-white text-base font-medium rounded-md text-white bg-transparent hover:bg-white hover:bg-opacity-10 transition duration-300 cursor-not-allowed"
                disabled
              >
                <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
                </svg>
                Download on App Store
              </button>
              <span className="absolute -top-2 -right-2 bg-yellow-500 text-white text-xs px-2 py-1 rounded-full">
                Coming Soon
              </span>
            </div>
          </div>
        </div>
      </section>




      {/* Footer */}
      <footer className="bg-[#103c2c] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              {/* <h3 className="text-2xl font-bold text-green-400 mb-4">EventIQ</h3> */}
              <img className="w-[200px]" src={eventBg} alt="EventIQ logo" />
              <p className="text-gray-400 mt-3">
                Sustainable digital event management platform for smarter, eco-friendly events.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><a href="#features" className="text-gray-400 hover:text-white transition">Features</a></li>
                <li><a href="#how-it-works" className="text-gray-400 hover:text-white transition">How It Works</a></li>
                <li><a href="#sustainability" className="text-gray-400 hover:text-white transition">Sustainability</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Legal</h4>
              <ul className="space-y-2">
                <li><a href="/apps/eventiq/privacy" className="text-gray-400 hover:text-white transition">Privacy Policy</a></li>
                <li><a href="/apps/eventiq/terms" className="text-gray-400 hover:text-white transition">Terms of Use</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Developer: Divya HM</li>
                <li>Company: Binalogy</li>
                <li>Email: divya@binalogy.in</li>
                <li>Location: Bangalore, India</li>
              </ul>
            </div>
          </div>


        </div>
      </footer>
    </div>
  );
};

export default LandingPage;